import React, { useContext } from "react";
import { Layout } from "antd";
import { RouteComponentProps } from "react-router";
import Sidebar from "../activity/Sidebar";
import { Header } from "../shared/Header";
import { MainContext } from "@Context/provider";
import { ViewMode } from "@Context/state";
import "@Styles/main.scss";
import AutomationActions from "@Components/shared/AutomationActions";

type IProps = RouteComponentProps & { children: any };

const MainLayout: React.FC<IProps> = (props: IProps) => {
    const { Content } = Layout;
    const { ui: uiState } = useContext(MainContext);
    return (
        <div id="main-layout">
            <Layout style={{ height: "100%" }}>
                <Header />
                <Layout>
                    <Sidebar />
                    <div suppressHydrationWarning={true} id="content-wrapper" className="scrolling-content-wrapper">
                        <Content
                            id="main-layout-content"
                            className="main-layout-content"
                            style={uiState.mode === ViewMode.mobile ? { padding: 0 } : null}
                        >
                            {/* TODO: should only be shown to users that have permissions for demo mode */}
                            <AutomationActions />
                            {props.children}
                        </Content>
                    </div>
                </Layout>
            </Layout>
        </div>
    );
};

export default MainLayout;
